/* eslint-disable no-param-reassign */
import { DreamBlock } from '@typedream/core';
import {
  deselect,
  getEndPoint,
  getNode,
  isElement,
  select,
  setElements,
} from '@udecode/plate-core';
import { Path } from 'slate';
import { isTextBlock } from '../../editorTools/queries';
import { DreamEditor } from '../../types';
import { getSelectedElementEntry } from './queries';

export const selectElement = (
  editor: DreamEditor,
  path: Path,
  multi?: boolean,
) => {
  const {
    store: { getState, setState },
  } = editor;
  const { selectedElementPaths } = getState();

  if (
    !multi
    && selectedElementPaths.length === 1
    && Path.equals(selectedElementPaths[0], path)
  ) {
    return;
  }

  if (!multi) {
    // Replace existing selection
    setState({ selectedElementPaths: [path] });
  } else if (selectedElementPaths.some((p) => Path.equals(p, path))) {
    // Deselect when selecting a selected block
    setState({
      selectedElementPaths: selectedElementPaths.filter(
        (p) => !Path.equals(p, path),
      ),
    });
  } else {
    setState({
      selectedElementPaths: [
        path,
        // Check if one of the selected ones are an ancestor or descendant,
        // select the latest selected one, and deselect ancestor or descendant
        ...selectedElementPaths.filter(
          (p) => !(Path.isAncestor(p, path) || Path.isDescendant(p, path)),
        ),
      ],
    });
  }
};

export const deselectElements = (editor: DreamEditor) => {
  const {
    store: { getState, setState },
  } = editor;
  const { selectedElementPaths } = getState();
  if (selectedElementPaths.length === 0) return;
  setState({ selectedElementPaths: [] });
};

export const resizeSelectedElement = (
  editor: DreamEditor,
  sizes: { height?: number; width?: number },
) => {
  const selectedElementEntry = getSelectedElementEntry(editor);

  if (!selectedElementEntry) return;

  setElements(editor, sizes, { at: selectedElementEntry[1] });
};
